import {BaseContainerModel} from '../../base-container.model';

export class MembershipPointsCurrentBalanceDto extends BaseContainerModel {
  public point_balance: string;
  public point_currency: string;
}
